<script lang="ts">

    export let date: Date | string;

    let dateFormat: string = '';

    $: formatDate(date);

    function formatDate(date: Date | string): void {
        
        if (!date) {
            dateFormat = '';
            return;
        } 

        const formatter = new Intl.DateTimeFormat('es-ES', {
            dateStyle: 'medium',
            timeStyle: 'short'
        });

        if (typeof date === 'string') {
            date = new Date(date);
        }
        
        dateFormat = formatter.format(date);
    } 

</script>

{dateFormat}
